/**
 * "Ask the agent": type the prompt into the agent column where the broker
 * already is, or fall back to `/agent` (spec cova-feed/2026-10-09-001 §6.4).
 *
 * Above 0 mounted columns, the prompt lands in the column's input and the
 * column opens; nothing is submitted. At 0 (a page with `hideAgentPanel`, a
 * page outside `DashboardLayout`, or `agent_v2_sidebar` off) it goes to
 * `/agent?q=…&prefill=draft`, which types the prompt there without sending it.
 *
 * The agent-sidebar barrel is imported at CLICK time, not at module load: this
 * runs from the root layout, and a static import would put the agent column's
 * whole module graph in every page's first bundle for a once-in-a-while click.
 */
export async function openAgentPrompt(prompt: string, push: (href: string) => void): Promise<"column" | "page"> {
  const { useAgentColumnPresenceStore, useAgentSidebarInputStore, useAgentPanelStore } = await import(
    "@/features/agent-v2/agent-sidebar"
  )
  if (useAgentColumnPresenceStore.getState().mounted > 0) {
    useAgentSidebarInputStore.getState().setValue(prompt)
    useAgentPanelStore.getState().open()
    return "column"
  }
  push(agentFallbackHref(prompt))
  return "page"
}

export const agentFallbackHref = (prompt: string): string =>
  `/agent?q=${encodeURIComponent(prompt)}&prefill=draft`
